export default __webpack_public_path__ + "static/media/icon-back.3c032480.svg";